import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router";
import AppShell from "../layouts/AppShell.vue";
import { useAuthStore } from "../stores/auth";
import type { Role } from "../lib/types";

declare module "vue-router" {
  interface RouteMeta {
    public?: boolean;
    roles?: Role[];
  }
}

const routes: RouteRecordRaw[] = [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/LoginView.vue"),
    meta: { public: true },
  },
  {
    path: "/",
    component: AppShell,
    children: [
      {
        path: "",
        name: "home",
        component: () => import("../views/DashboardView.vue"),
        meta: { roles: ["admin"] },
      },
      {
        path: "usuarios",
        component: () => import("../views/UsersView.vue"),
        meta: { roles: ["admin"] },
      },
      {
        path: "licencias",
        component: () => import("../views/LicencesView.vue"),
        meta: { roles: ["admin", "operator", "viewer"] },
      },
      {
        path: "equipos",
        component: () => import("../views/DevicesView.vue"),
        meta: { roles: ["admin", "operator", "viewer"] },
      },
      {
        path: "historial",
        component: () => import("../views/HistoriesView.vue"),
        meta: { roles: ["admin"] },
      },
      {
        path: "otp",
        component: () => import("../views/OtpDiagnosticsView.vue"),
        meta: { roles: ["admin"] },
      },
      {
        path: "planes",
        component: () => import("../views/PlansView.vue"),
        meta: { roles: ["admin", "operator"] },
      },
      {
        path: "mercadopago",
        component: () => import("../views/MercadoPagoView.vue"),
        meta: { roles: ["admin", "operator"] },
      },
      {
        path: "archivos",
        component: () => import("../views/FilesView.vue"),
        meta: { roles: ["admin", "operator"] },
      },
      {
        path: "variables",
        component: () => import("../views/VariablesView.vue"),
        meta: { roles: ["admin", "operator"] },
      },
      {
        path: "tokens",
        component: () => import("../views/TokensView.vue"),
        meta: { roles: ["admin", "operator"] },
      },
      {
        path: "errores",
        component: () => import("../views/CrashesView.vue"),
        meta: { roles: ["admin", "operator"] },
      },
      {
        path: "sugerencias",
        component: () => import("../views/FeedbackView.vue"),
        meta: { roles: ["admin", "operator"] },
      },
      {
        path: "tickets",
        component: () => import("../views/TicketsView.vue"),
        meta: { roles: ["admin", "operator"] },
      },
      {
        path: "productos",
        component: () => import("../views/ProductsView.vue"),
        meta: { roles: ["admin", "operator"] },
      },
      {
        path: "chat",
        component: () => import("../views/ChatView.vue"),
        meta: { roles: ["admin", "operator"] },
      },
      {
        path: "configuracion",
        component: () => import("../views/SettingsView.vue"),
        meta: { roles: ["admin", "operator", "viewer"] },
      },
    ],
  },
  { path: "/:pathMatch(.*)*", redirect: "/" },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 }),
});

router.beforeEach((to) => {
  const auth = useAuthStore();
  if (to.meta.public) {
    return auth.user ? (auth.user.role === "admin" ? "/" : "/licencias") : true;
  }
  if (!auth.user) return { name: "login", query: { redirect: to.fullPath } };
  if (to.meta.roles && !to.meta.roles.includes(auth.user.role)) {
    return auth.user.role === "admin" ? "/" : "/licencias";
  }
  return true;
});

export default router;
